/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Create_FailedInputs */

const en_cargo_create_failed = /** @type {(inputs: Cargo_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create cargo`)
};

const es_cargo_create_failed = /** @type {(inputs: Cargo_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo crear la carga`)
};

/**
* | output |
* | --- |
* | "Failed to create cargo" |
*
* @param {Cargo_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_create_failed = /** @type {((inputs?: Cargo_Create_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Create_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_create_failed(inputs)
	return es_cargo_create_failed(inputs)
});